import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  Fab,
  DialogActions,
} from '@material-ui/core';
import { DeleteOutline } from '@material-ui/icons';
import { pasarErrorEvolucionOdonto } from '../../../../actions/hce/hceActions';

export const ModalDetalleEvoluciones = (props) => {
  const { evolucionesOdontologia } = useSelector((state) => state.hce);
  const { hce } = props;
  const dispatch = useDispatch();
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleDelete = () => {
    setConfirmOpen(!confirmOpen);
  };

  return (
    <Dialog fullWidth maxWidth="md" open={props.open} onClose={props.close}>
      <DialogTitle>{props.titulo}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{ paddingLeft: 16 }}
          >
            {Array.isArray(evolucionesOdontologia) &&
            evolucionesOdontologia?.length > 0 ? (
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Evolucion</TableCell>
                    <TableCell>Profesional</TableCell>
                    <TableCell>Borrar</TableCell>
                  </TableRow>
                </TableHead>
                {evolucionesOdontologia.map((evolucion, index) => {
                  if (evolucion?.pasadoAError !== null) {
                    return null; // No retorna nada si evolucion.pasadarError es null
                  } else {
                    return (
                      <TableBody key={index}>
                        <TableCell>{evolucion?.evolucion}</TableCell>
                        <TableCell>{evolucion?.nombreEfector}</TableCell>
                        {evolucion?.idEfectorRed === hce.idEfector && (
                          <TableCell>
                            <Fab
                              color="primary"
                              aria-label="add"
                              size="small"
                              onClick={handleDelete}
                            >
                              <DeleteOutline />
                            </Fab>
                            <Dialog open={confirmOpen} onClose={handleDelete}>
                              <DialogTitle>Mensaje</DialogTitle>
                              <DialogContent>
                                <Typography>
                                  ¿Estás seguro de que deseas pasar a error el
                                  diagnostico?
                                </Typography>
                              </DialogContent>
                              <DialogActions>
                                <Button
                                  variant="contained"
                                  color="secondary"
                                  onClick={() => {
                                    const data = {
                                      id: evolucion.id,
                                    };
                                    dispatch(
                                      pasarErrorEvolucionOdonto(
                                        data,
                                        evolucion.idProblemaOdontologia,
                                      ),
                                    );
                                    setConfirmOpen(false);
                                  }}
                                >
                                  Sí
                                </Button>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  onClick={handleDelete}
                                >
                                  No
                                </Button>
                              </DialogActions>
                            </Dialog>
                          </TableCell>
                        )}
                      </TableBody>
                    );
                  }
                })}
              </Table>
            ) : (
              <Typography style={{ fontSize: '1.1rem', fontStyle: 'italic' }}>
                No hay evoluciones
              </Typography>
            )}
          </Grid>
        </Grid>
        <div
          style={{
            margin: '1rem 0',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-evenly',
          }}
        >
          <Button variant="contained" color="primary" onClick={props.close}>
            Cancelar
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
